<template>
  <thanks-main :thanks="thanks" />
</template>

<script setup lang="ts">
import { BookingThanksRepositoryFetch } from '../../../apps/thanks/BookingThanksRepositoryFetch'

definePageMeta({
  layout: 'no-navbar',
})

const nuxtApp = useNuxtApp()

useHead({
  title: (nuxtApp.$t('Thank you for your booking') +
    ' | Pitchup.com') as string,
  meta: [
    {
      hid: 'robots',
      name: 'robots',
      content: 'noindex',
    },
  ],
})

const { data: thanks, error } = await useAsyncData(
  `thanks-${useRoute().params.signature}`,
  async () => {
    const route = useRouter().currentRoute.value
    const repository = new BookingThanksRepositoryFetch()
    const thanks = await repository.getOneByToken(
      (route.params.lang as string) || 'en-gb',
      route.params.signature as string,
      route.query,
    )
    return thanks
  },
)

if (error.value) {
  // Log the actual error for debugging
  console.error('Booking thanks page error:', {
    signature: useRoute().params.signature,
    error: error.value,
    message: error.value.message,
    statusCode: error.value.statusCode,
    data: error.value.data,
  })

  throw createError({
    statusCode: error.value.statusCode || 500,
    statusMessage:
      error.value.statusMessage || error.value.message || 'Booking not found',
    message: error.value.message || 'Unable to load booking confirmation',
    fatal: process.client, // Only set fatal true on client-side
  })
}
</script>
